import { RoundedChip } from "@data-display/RoundedChip";
import { ResponsiveButton } from "@data-display/wrapper/ResponsiveButton";
import { ArrowDropDown, Close, SettingsBackupRestore } from "@mui/icons-material";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { type IResponsiveFiltersProps, ResponsiveFiltersDisplay } from ".";

export const CompactFilters = ({ filters, onReset, display, breakpoint }: IResponsiveFiltersProps) => {
  const [open, setOpen] = useState(false);
  const isLg = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const onOpen = useCallback(() => {
    setOpen(true);
    for (const f of filters) {
      f.onOpen();
    }
  }, [filters]);
  const onClose = useCallback(() => {
    setOpen(false);
    for (const f of filters) {
      f.onClose();
    }
  }, [filters]);
  const totalBadgeCount = useMemo(() => filters.reduce((count, f) => count + f.badgeCount, 0), [filters]);

  return (
    <>
      {display === ResponsiveFiltersDisplay.DASHBOARD ? (
        <Badge badgeContent={totalBadgeCount} color="yellow">
          <ResponsiveButton
            sx={{
              backgroundColor: isLg ? "white" : "white",
              ":hover": {
                backgroundColor: "inherit",
              },
            }}
            variant="outlined"
            startIcon={<TuneIcon />}
            onClick={onOpen}
            breakpoint={breakpoint}
          />
        </Badge>
      ) : (
        <Button
          variant="filter"
          endIcon={<ArrowDropDown />}
          onClick={onOpen}
          sx={{
            width: "110px",
          }}
        >
          <span>Filtres</span>
          {totalBadgeCount > 0 && <RoundedChip label={totalBadgeCount} color="yellow" size="small" sx={{ ml: 0.5 }} />}
        </Button>
      )}
      <Dialog scroll="paper" fullScreen open={open} onClose={() => setOpen(false)}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4">Filtres</Typography>
          <IconButton onClick={() => setOpen(false)}>
            <Close color="primary" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Stack
            sx={{
              gap: 3,
              alignItems: "start",
            }}
          >
            {filters.map((f) => (
              <Stack
                key={f.label}
                sx={{
                  gap: 1,
                }}
              >
                <Typography variant="subtitle2SemiBold" color="primary">
                  {f.label}
                </Typography>
                {f.content}
              </Stack>
            ))}
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            zIndex: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          <Button
            variant="text"
            startIcon={<SettingsBackupRestore />}
            onClick={() => {
              onReset();
              setOpen(false);
            }}
            sx={{
              textDecoration: "underline",
              textDecorationThickness: "2px",
            }}
          >
            Réinitialiser
          </Button>
          <Button variant="contained" color="primary" onClick={onClose}>
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
